import React from 'react';
import './sec1.css'
import Herotext from '../components/common/hero-text';



const Sec1 = () => {
    return ( 
        <section className='sec1'>
            <figure className='background-sec1'>
                <article className='big-container-sec1'>
                    <article className='container-sec1'>
                            <Herotext title='Find Your Place' para='Experience modern homes crafted for
                            
                            comfort, style, and the lifestyle you deserve.' />
                    </article>
                </article>
            </figure>
        </section>
     );
}
 
export default Sec1;